<template>
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
            fill="url(#paint0_linear_14454_209591)"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.6502 7.27295H9.35128C8.79988 7.27333 8.2712 7.49265 7.88144 7.88268C7.49168 8.27272 7.27274 8.80155 7.27274 9.35295V22.6504C7.27274 23.7966 8.20364 24.7275 9.35274 24.7275H22.6502C23.7964 24.7275 24.7273 23.7966 24.7273 22.6504V9.35149C24.7269 8.8006 24.508 8.27236 24.1186 7.88268C23.7292 7.493 23.2011 7.27372 22.6502 7.27295ZM20.9862 13.5071H20.1556C19.2669 13.5071 18.9091 13.7137 18.9091 14.3377V15.5857H20.9862L20.5716 17.6628H18.9091V23.8969H16.832V17.6628H15.168V15.5857H16.832V14.3377C16.832 12.6766 17.6626 11.4286 19.3251 11.4286C20.5295 11.4286 20.9862 11.8446 20.9862 11.8446V13.5071Z"
            fill="white"
        />
        <defs>
            <linearGradient
                id="paint0_linear_14454_209591"
                x1="32"
                y1="-149.488"
                x2="32"
                y2="275.132"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#087AFF" />
                <stop offset="1" stop-color="#3CA4FF" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    name: "FacebookIcon",
};
</script>
